module.exports = __webpack_public_path__ + "b1728e039448d851094c31e0cdf882b1.pdf";